import { SaveAlt } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import React from 'react';
import Swal from 'sweetalert2';
import { formatDateTime } from '../../../utils/dateUtils';
import { CartService } from './Service';

const ExportAll = (props) => {
  const { paginationModel } = props;

  // Define custom headers and their corresponding data mapping
  const exportMapping = [
    {
      header: 'Cart ID',
      value: (row) => `${row.id}`
    },
    {
      header: 'CustomerId',
      value: (row) => `${row?.customerId}`
    },
    {
      header: 'Customer Name',
      value: (row) => `${row?.Customer?.profile?.firstName || ''} ${row?.Customer?.profile?.middleName || ''} ${row?.Customer?.profile?.lastName || ''}`
    },
    {
      header: 'Customer Contact',
      value: (row) => `${row?.Customer?.mobileNumber}`
    },
    {
      header: 'ExpertId',
      value: (row) => `${row?.providerId}`
    },
    {
      header: 'Expert Name',
      value: (row) => `${row?.User?.UserProfile?.firstName || ''} ${row?.User?.UserProfile?.middleName || ''} ${row?.User?.UserProfile?.lastName || ''}`
    },
    {
      header: 'Expert Contact',
      value: (row) => `${row?.User?.mobileNumber}`
    },
    {
      header: 'Creation Date',
      value: (row) => formatDateTime(row.createdAt)
    }
  ];

  const handleExportAllRows = async () => {
    try {
      Swal.fire({
        title: 'Exporting Data',
        text: 'Please wait while we prepare your download...',
        icon: 'info',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const listResponse = await CartService.getExportCartList({
        filters: {
          searchKey: paginationModel.filters.searchKey,
          sortBy: paginationModel.filters.sortBy,
          sortType: paginationModel.filters.sortType,
          filterOptions: paginationModel.filters.filterOptions || []
        }
      });

      // Transform data using custom mapping
      const exportData = listResponse.data.list.map(row => {
        return exportMapping.reduce((acc, field) => {
          acc[field.header] = field.value(row);
          return acc;
        }, {});
      });

      // Create CSV content
      const headers = exportMapping.map(field => `"${field.header}"`).join(',');
      const csvContent = exportData.map(row => 
        exportMapping.map(field => 
          `"${String(row[field.header] ?? '').replace(/"/g, '""')}"`
        ).join(',')
      );

      csvContent.unshift(headers);

      // Create and download file
      const csvString = csvContent.join('\n');
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Abandoned-Cart-Report.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Swal.fire({
        title: 'Export Successful',
        html: `
          <p>If download doesn't start automatically, click on provided link:
          <a href="${url}" download="ServiceExpert-report.csv" style="color: blue; text-decoration: underline;">
            Download CSV
          </a></p>
        `,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonText: 'Close'
      });

    } catch (error) {
      console.error('Export failed', error);
      
      Swal.fire({
        title: 'Export Failed',
        text: 'There was an issue exporting the data. Please try again.',
        icon: 'error'
      });
    }
  };

  return (
    <Box>        
      <Button 
        onClick={handleExportAllRows}
        startIcon={<SaveAlt />}
        sx={{textTransform:'none'}}
      >
        Export
      </Button>      
    </Box>
  );
}

export default ExportAll;